import { createFileRoute } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'

const Page = lazy(() => import('~/features/samtek/products/page-client'))

export const Route = createFileRoute('/_authed/samtek/product-list')({
  component: () => <Suspense fallback={null}><Page /></Suspense>,
})
